import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites', 'key']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack', 'setUser', 'setModal']),
    ...mapActions(['getSessions', 'getUser']),
    formatDay(day) {
      if (!day) return '';
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name]);
    },
    formatPerson(person) {
      return person;
    },
    formatLanguage(language) {
      switch(language){
        case 331:
        return 'Deutsch';
        case 332:
        return 'Englisch';
        case 333:
        return 'Englisch/Deutsch';
      }
    },
  }
})

export default mixins